import React from "react";

const skills = [
  "JavaScript (ES6+)", "Kotlin", "React.js", "Vue.js", "Angular",
  "Node.js", "PHP", "Solidity", "Web3.js", "Ethers.js",
  "Ethereum", "Binance Smart Chain", "Celo", "Hardhat",
  "MySQL", "PostgreSQL", "MongoDB", "AWS", "Azure", "GCP"
];

export default function Skills() {
  return (
    <section id="skills" className="bg-gray-100 dark:bg-blue-900 py-16 px-6">
      <h2 className="text-3xl font-bold text-center text-blue-600 mb-8">Technical Skills</h2>
      <div className="max-w-5xl mx-auto grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {skills.map((skill, idx) => (
          <div
            key={idx}
            className="bg-white rounded-lg shadow-md p-4 text-center font-medium hover:shadow-lg transition"
          >
            {skill}
          </div>
        ))}
      </div>
    </section>
  );
}
